module.exports = __webpack_public_path__ + "img/card05.39acffb4.png";